@if (enabled$ | async) {
  @if (data$ | async; as data) {
    <a
      class="sh-list-row-title"
      (click)="linkClicked(data, $event)"
      [shNavigationLink]="navigationLink$ | async"
      [title]="value$ | async"
      >
      <h3 class="sh-list-row-title__title">{{ value$ | async }}</h3>
    </a>
  }
} @else {
  @if (data$ | async; as data) {
    <div class="sh-list-row-title" (click)="recordSelected(data)" (keydown.enter)="recordSelected(data)" [title]="value$ | async">
      <h3 class="sh-list-row-title__title">{{ value$ | async }}</h3>
    </div>
  }
}


